import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { IHICustomer } from '../../interfaces/IHealthInsurance'
import { resetHICustomer } from '../../store/action'

import { Customer, DeleteIcon } from './style'

type Props = {
  customer: IHICustomer | null
}

export const PageTitle = ({ customer }: Props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const removeCustomerFromStore = () => dispatch(resetHICustomer())

  return (
    <>
      <h1>{t('New health insurance')}</h1>
      {customer ? (
        <Customer onClick={removeCustomerFromStore}>
          <DeleteIcon icon={faTrashAlt} />
          {`${customer.firstName} ${customer.lastName}`}
        </Customer>
      ) : null}
    </>
  )
}
